import React, { ReactElement } from "react"
import { BaseChoice, COChoice } from "interfaces/mappingInterfaces"
import Select, { SingleValue } from "react-select"
import { Button } from "@wfp/ui"

type Props = {
  coList: COChoice[]
  baseList: BaseChoice[]
  setCoList: React.Dispatch<React.SetStateAction<COChoice[]>>
}

const XlsChoiceMapping = ({ coList, baseList, setCoList }: Props): ReactElement => {
  const handleChange = (value: SingleValue<BaseChoice>, index: number): void => {
    const newList = [...coList]
    newList[index] = {
      ...newList[index],
      baseChoiceId: value?.listChoiceId ?? null,
      baseChoiceName: value?.listChoiceName ?? "",
      baseChoiceLabel: value?.listChoiceLabel ?? "",
      baseListId: value?.listId ?? 0,
    }
    setCoList(newList)
  }

  const handleAutomap = (): void => {
    const newList = [...coList]
    newList.forEach((item, index) => {
      const match = baseList.find(base => base.listChoiceName.toLowerCase() === item.choiceName.toLowerCase())
      if (match) {
        newList[index] = {
          ...newList[index],
          baseChoiceId: match.listChoiceId ?? null,
          baseChoiceName: match.listChoiceName,
          baseChoiceLabel: match.listChoiceLabel,
          baseListId: match.listId,
          warning: match.listChoiceLabel !== item.choiceLabel,
        }
      }
    })
    setCoList(newList)
  }

  return (
    <div>
      <div className="flex my-1">
        <div className="w-6/12">
          <h5>CO Choices</h5>
        </div>
        <div className="w-6/12 ps-4 flex items-center justify-between">
          <h5>Base HQ Choices</h5>
          <Button onClick={handleAutomap}>Automap</Button>
        </div>
      </div>

      {coList.map((item, index) => (
        <div
          key={item.choiceId}
          className="flex justify-between items-center py-1 border-gray-300 border-b border-solid"
        >
          <div className={`${item?.warning ? "bg-yellow-200" : ""} p-2 rounded-sm w-1/2`}>
            {item.choiceName} {item.choiceLabel}
          </div>
          <div className="w-6/12 ps-4">
            <Select
              options={baseList}
              placeholder="unmapped"
              getOptionLabel={option =>
                `${option.listChoiceName === "-1" ? "" : option.listChoiceName} ${option.listChoiceLabel}`
              }
              getOptionValue={option => option.listChoiceId?.toString() ?? "-1"}
              isClearable
              value={baseList.find(base => base.listChoiceName === item.baseChoiceName)}
              onChange={value => handleChange(value, index)}
              menuPlacement="auto"
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default XlsChoiceMapping
